import React from 'react';
import { DatoCmsInformationSectionAccordion } from '../../../schema/datocms/blocks/information-section-accordion';
import Accordion from '../../accordion/accordion';
import HtmlStringComponent from '../../html-string/html-string-component';

const InformationSectionAccordionComponent =  ( {summary, mainTextHtml, componentId,  ...rest}: DatoCmsInformationSectionAccordion): React.ReactElement => {

    return (
        <Accordion
            title={summary}
            internalSectionComponentId={componentId}
            classes={{
                details: 'w-full information-section-accordion',
                summary: 'items-center focus:outline-white',
                summaryText: 'order-2 py-5 font-bold text-lg',
                icon: 'order-1 text-current fill-current'
            }}>
            <div>
                { mainTextHtml && <HtmlStringComponent htmlString={mainTextHtml} className={'px-8'}/>}
            </div>
        </Accordion>
    );
};

export default InformationSectionAccordionComponent;
